import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthService } from 'app/core/auth/auth.service';
import { AccessTokenInterceptor } from './access-token.interceptor';
// import { AuthInterceptor } from 'app/core/auth/auth.interceptor';
import { DEVICE_TRACKING_PROVIDERS } from 'app/core/device/device-tracking.providers';

@NgModule({
    imports  : [
        HttpClientModule
    ],
    providers: [
        AuthService,
        {
            provide : HTTP_INTERCEPTORS,
            useClass: AccessTokenInterceptor,
            multi   : true
        },
        // {
        //     provide : HTTP_INTERCEPTORS,
        //     useClass : AuthInterceptor,
        //     multi : true
        // }
        DEVICE_TRACKING_PROVIDERS
    ]
})
export class AuthModule
{
}
